import { useMemo } from 'react';
import useT from './useT';
export default function useLabel(defaultLabel, label) {
    const t = useT();
    return useMemo(() => label || t(defaultLabel), [defaultLabel, label, t]);
}
